import { ACCESS_TOKEN, Core, SUBMIT_FOI_REQUEST } from '@services/Core';
import { AxiosPromise } from 'axios';

const FOI_REQUEST_TOKEN = process.env.REACT_APP_IBS_REQUEST_TOKEN;

interface GetAccessToken {
  (): AxiosPromise<{ access_token: string }>;
}

interface IFOISubmit {
  (data: FormData, token: string): AxiosPromise;
}

class FOIRequest extends Core {
  getAccessToken: GetAccessToken = async () => {
    const formData = new URLSearchParams();
    formData.append('grant_type', 'client_credentials');
    return this.post(`${ACCESS_TOKEN}`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Basic ${FOI_REQUEST_TOKEN}`,
      },
      transformRequest: [
        (data, headers) => {
          headers['Content-Type'] = 'application/x-www-form-urlencoded';
          return data;
        },
      ],
    });
  };
  submitFOIRequest: IFOISubmit = async (data, token) =>
    this.post(SUBMIT_FOI_REQUEST(), data, {
      headers: { Authorization: `Bearer ${token}` },
    });
}

export const foiRequest = new FOIRequest();
